


































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { BulletinModule } from '@/app/store/modules/bulletin'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { defaultImage } from '@/utils/default'

@Component({
  components: {
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) public imageDataCategory
  @Prop({}) public id
  @Prop({}) public title
  @Prop({}) public isActive
  @Prop({}) public isRecommended
  @Prop({}) public idModal
  @Prop({}) public imageThumbnail
  @Prop({}) public imageCover
  @Prop({}) public file
  @Prop({}) public freeText1
  @Prop({}) public freeText2
  @Prop({}) public dateTimeexpired
  // Property Base64
  public hasFiles = {
    fileName: '',
    fileByte: '',
    fileUpload: null,
  }
  public disableDate(date) {
    return date < new Date()
  }

  // public placeHolder = this.file.name;
  public get stateTitle() {
    return this.title.length > 3 ? true : false
  }
  public get stateExpiredDate() {
    return this.dateTimeexpired !== null ? true : false
  }

  public get stateFreeText1() {
    return this.freeText1.length > 1 ? true : false
  }
  public get stateFreeText2() {
    return this.freeText2.length > 2 ? true : false
  }
  // Property Select Status
  public optionsIsActive: any = [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false },
  ]

  // Property Select Recomended
  public optionsIsRecommended: any = [
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ]

  public base64Pdf(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles = {
          fileName: input.files[0].name,
          fileByte: hash.length ? hash[1] : '',
          fileUpload: input.files[0],
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  public onPaste(evt) {
    return evt.preventDefault()
  }

  // // validate input sales-code
  // // @keypress="freeTextPress($event)" if you want imlement in html
  // public freeTextPress(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (this.freeText.length > 4) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }
  // public monthPress(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (
  //     this.month.length > 1 ||
  //     (charCode > 31 && (charCode < 48 || charCode > 57))
  //   ) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }
  // public yearPress(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (
  //     this.year.length > 3 ||
  //     (charCode > 31 && (charCode < 48 || charCode > 57))
  //   ) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }

  public patchNotif(item, index, button) {
    if (
      this.stateTitle === false ||
      this.stateFreeText1 === false ||
      this.stateFreeText2 === false ||
      this.dateTimeexpired === null
    ) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        title: this.title,
        fileCode: this.freeText1 + '-' + this.freeText2,
        imageThumbnailId: this.imageThumbnail.image_id,
        isActive: this.isActive,
        isRecommended: this.isRecommended,
        fileName: this.hasFiles.fileName,
        fileByte: this.hasFiles.fileByte,
        fileUpload: this.hasFiles.fileUpload,
        expireddate: this.dateTimeexpired,
      }
      BulletinModule.updateBulletin(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'modal-edit', button)
    }
  }

  public changeImageThumbnailId(item) {
    this.imageThumbnail.image_id = item.id
    this.imageThumbnail.link = item.link
  }
  public cancelImageThumbnailId() {
    this.imageThumbnail.id = null
    this.imageThumbnail.link = defaultImage
  }
}
